/* תפריט-על — פתיחה במקלדת, סגירה ב-Escape, aria-expanded מסונכרן.
   ה-hover נשאר לגמרי ב-CSS; הקובץ הזה מוסיף רק את מה שעכבר לא נותן.
   ת"י 5568 רמה AA היא דרישה חוקית בחנות הזאת, לא שיפור. */
(function () {
  'use strict';

  var OPEN = 'jm-mega-open';
  var MEGA = '[data-jm-mega]';
  var TOGGLE = '[data-jm-mega-toggle]';

  function setState(li, open) {
    if (!li) return;
    li.classList.toggle(OPEN, open);
    li.classList.toggle('jm-mega-dismissed', !open);
    var btn = li.querySelector(TOGGLE);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    var list = document.querySelectorAll(MEGA + '.' + OPEN);
    for (var i = 0; i < list.length; i++) {
      if (list[i] !== except) setState(list[i], false);
    }
  }

  // Match the native hover panel with the button's accessible state.
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    var li = event.target.closest && event.target.closest(MEGA);
    if (!li || li.contains(event.relatedTarget)) return;
    closeAll(li);
    setState(li, true);
  });

  document.addEventListener('pointerout', function (event) {
    var li = event.target.closest && event.target.closest(MEGA);
    if (!li || li.contains(event.relatedTarget)) return;
    if (!li.contains(document.activeElement)) setState(li, false);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var btn = target.closest(TOGGLE);
    if (btn) {
      event.preventDefault();
      var li = btn.closest(MEGA);
      var isOpen = li && li.classList.contains(OPEN);
      closeAll(li);
      setState(li, !isOpen);
      return;
    }

    if (!target.closest(MEGA)) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var li = document.querySelector(MEGA + '.' + OPEN);
    if (!li) return;
    var btn = li.querySelector(TOGGLE);
    closeAll(null);
    if (btn) btn.focus();
  });

  /* יציאה מהפאנל עם Tab סוגרת אותו — בלי ללכוד את הפוקוס בפנים. */
  document.addEventListener('focusout', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var li = target.closest(MEGA);
    if (!li || !li.classList.contains(OPEN)) return;
    window.setTimeout(function () {
      if (!li.contains(document.activeElement)) setState(li, false);
    }, 0);
  });

  function syncMobileRows() {
      // Sliding layers keep their old rows in the DOM: exclude those rows
      // from the drawer's existing focus trap until the user goes back.
      var menus = document.querySelectorAll('.site-nav-mobile');
      for (var m = 0; m < menus.length; m++) {
        var menu = menus[m];
        var rootRows = menu.querySelectorAll(':scope > li > .jm-nav-row, :scope > li > .site-nav__link--main');
        var hasFirstLayer = !!menu.querySelector('.direc1.act');
        for (var r = 0; r < rootRows.length; r++) rootRows[r].inert = hasFirstLayer;
        var secondRows = menu.querySelectorAll('.jm-nav-row-2');
        var hasSecondLayer = !!menu.querySelector('.direc2.act');
        for (var n = 0; n < secondRows.length; n++) secondRows[n].inert = hasSecondLayer;
        var firstHeadings = menu.querySelectorAll('.nav-xs-lv1 > .navbar');
        for (var h = 0; h < firstHeadings.length; h++) firstHeadings[h].inert = hasSecondLayer;
      }
  }

  var mobileObserver = new MutationObserver(syncMobileRows);
  function observeMobileLayers() {
    var arrows = document.querySelectorAll('.site-nav-mobile .direc1, .site-nav-mobile .direc2');
    for (var i = 0; i < arrows.length; i++) {
      mobileObserver.observe(arrows[i], { attributes: true, attributeFilter: ['class'] });
    }
    syncMobileRows();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeMobileLayers);
  else observeMobileLayers();
  document.addEventListener('shopify:section:load', observeMobileLayers);

  /* ניווט הנייד: החץ הוא כפתור, ומצב הפתיחה שלו נמסר למקריא מסך.
     ה-toggle עצמו נשאר של ערכת הנושא (מחלקת act); כאן רק מסונכרן
     aria-expanded איתו. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var arrow = target.closest('.site-nav-mobile .direc1, .site-nav-mobile .direc2');
    var back = target.closest('.site-nav-mobile [class*="direcback"]');
    if (!arrow && !back) return;
    window.setTimeout(function () {
      var all = document.querySelectorAll('.site-nav-mobile .direc1, .site-nav-mobile .direc2');
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute('aria-expanded', all[i].classList.contains('act') ? 'true' : 'false');
      }
      syncMobileRows();
      var panel = arrow ? arrow.closest('li') : null;
      if (back) {
        var previous = back.closest('.nav-xs-lv2, .nav-xs-lv1');
        var owner = previous && previous.parentElement;
        var trigger = owner && owner.querySelector('.jm-nav-row > .site-nav-direc');
        if (trigger) trigger.focus();
      }
      if (panel) {
        var heading = panel.querySelector('.navbar [class*="direcback"]');
        if (heading) heading.focus();
      }
    }, 0);
  });
})();
